import { Stack, Text } from '@mantine/core';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';

export const DetailBlock = ({ label, value }: { label: string; value: string | null }) => {
	if (!value) {
		return null;
	}
	return (
		<Stack gap={2}>
			<Text size="sm" fw={600} c={defaultTheme.v3.colors.dark[2]}>
				{label}
			</Text>
			<Text size="sm" style={{ wordBreak: 'break-word' }}>
				{value}
			</Text>
		</Stack>
	);
};
